export enum actionTypes {
  MOTIVOS_FINALIZACION_FETCH = 'MOTIVOS_FINALIZACION_FETCH',
  MOTIVOS_FINALIZACION_SUCCESS = 'MOTIVOS_FINALIZACION_SUCCESS',
  MOTIVOS_FINALIZACION_ERROR = 'MOTIVOS_FINALIZACION_ERROR',
  MOTIVOS_FINALIZACION_RESET = 'MOTIVOS_FINALIZACION_RESET',
}

export enum MotivosFinalizacionStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface MotivoFinalizacion {
  id: number
  descripcion: string
}

export interface MotivosFinalizacionState {
  status: MotivosFinalizacionStatus
  motivosFinalizacion: Array<MotivoFinalizacion>
}

export interface MotivosFinalizacionFetch {
  type: typeof actionTypes.MOTIVOS_FINALIZACION_FETCH
  payload: null
}

export interface MotivosFinalizacionSuccess {
  type: typeof actionTypes.MOTIVOS_FINALIZACION_SUCCESS
  payload: { motivosFinalizacion }
}

export interface MotivosFinalizacionError {
  type: typeof actionTypes.MOTIVOS_FINALIZACION_ERROR
  payload: null
}

export interface MotivosFinalizacionReset {
  type: typeof actionTypes.MOTIVOS_FINALIZACION_RESET
  payload: null
}

export type MotivosFinalizacionActions = MotivosFinalizacionFetch | MotivosFinalizacionSuccess | MotivosFinalizacionError | MotivosFinalizacionReset

export const initialState: MotivosFinalizacionState = {
  status: MotivosFinalizacionStatus.Idle,
  motivosFinalizacion: [],
}
